module.exports = __webpack_public_path__ + "static/media/2DGACM13.e9652fd3.jpg";